import React from "react"
import { View } from "react-ame-components"

export const BoxContainer = ({ children }) => {
  return (
    <View
      direction="column"
      justify="start"
      align="start"
      borderWidth="hairline"
      borderColor="neutral-300"
      borderRadius="small"
      padding="small">
      {children}
    </View>
  )
}
